var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app",class:_vm.$global.state.filter.search == 'شمس الغري' ? 'shake' : '',style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('mainlayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }